/* An optional reading guide. Native anchors remain the navigation mechanism. */
if (!customElements.get('nph-reading-guide')) {
  customElements.define('nph-reading-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const body = this.closest('.npc-info')?.querySelector('.npc-info__body');
      if (!body) return;
      const eligible = selector => [...body.querySelectorAll(selector)].filter(heading =>
        heading.textContent.trim() && !heading.closest('form,aside,[hidden]')
      );
      // The store's policy content uses h3 for numbered clauses.
      const primary = eligible('h2');
      const headings = primary.length >= 3 ? primary : eligible('h2,h3');
      if (headings.length < 3) return;
      const list = this.querySelector('ol');
      if (!list) return;
      const prefix = this.dataset.section || 'service';
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = `nph30-read-${prefix}-${index + 1}`;
          while (document.getElementById(id)) id += '-section';
          heading.id = id;
        }
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        const item = document.createElement('li');
        item.append(link);
        list.append(item);
      });
      this.dataset.ready = 'true';
      this.hidden = false;
    }
  });
}
